import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, Injectable, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { MissingTranslationHandler, MissingTranslationHandlerParams, provideMissingTranslationHandler, provideTranslateService, TranslateCompiler } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { routes } from './app.routes';

const LABELS_FOLDER: string = './i18n/';
const LABELS_FORMAT: string = '.json';

const ITALIAN: string = 'it';
const ITALIAN_LOCALE_ID: string = 'it-IT';
const CURRENCY: string = 'EUR';

registerLocaleData(localeIt);

@Injectable()
export class DefaultMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    console.warn(`Missing translation for key: ${params.key}`);
    return params.key;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withFetch()),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: LABELS_FOLDER,
        suffix: LABELS_FORMAT
      }),
      missingTranslationHandler: provideMissingTranslationHandler(DefaultMissingTranslationHandler),
      fallbackLang: ITALIAN,
      lang: ITALIAN
    }),
    { provide: TranslateCompiler, useClass: TranslateMessageFormatCompiler },
    { provide: LOCALE_ID, useValue: ITALIAN_LOCALE_ID },
    { provide: DEFAULT_CURRENCY_CODE, useValue: CURRENCY }
  ]
};
